var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioImageIcone5576E8805Da1B02B0055467Ed0Fdbb5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.57812,
    width: 94,
    height: 94,
    rx: 3,
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0003 61.9113C55.3641 61.9113 61.3337 55.9418 61.3337 48.578C61.3337 41.2142 55.3641 35.2446 48.0003 35.2446C40.6365 35.2446 34.667 41.2142 34.667 48.578C34.667 55.9418 40.6365 61.9113 48.0003 61.9113Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43.2446V53.9113",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.667 48.5781H53.3337",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioImageIcone5576E8805Da1B02B0055467Ed0Fdbb5);
export default __webpack_public_path__ + "static/media/portfolioImageIcon.e5576e8805da1b02b0055467ed0fdbb5.317a0ba650583d7263e177efa45d185b.svg";
export { ForwardRef as ReactComponent };